import $ from 'jquery';
import {isPhone} from './useragent';
import type Watcher from './watcher';

type Options = {
    /**
     * @param triggerEffects: array of effect names that should be triggered, when container1 uncovers elements in container2
     * @param reverseGarage: boolean - reverse garage effect: container1 is sticky on the bottom & container2 slides over it
     *
    */
    triggerEffects?: string[],
    reverseGarage?: boolean,
}
class StickyGarage {
    /**
     * @description: garage effect: container1 reveals container2, which is sticky on the top until it is fully revealed / higher z-index must be set on container1
     * @param triggerEffects: array of effect names that should be triggered, when container1 uncovers elements in container2
     * @param reverseGarage: reverse garage effect: container1 is sticky on the bottom & container2 slides over it / no need for setting z-index
     *
    */
    constructor(watcher: Watcher,
                container1: HTMLElement,
                container2: HTMLElement,

                options?: Options){

        const reverseGarage = options?.reverseGarage;

        // content für position: sticky in .sticky-wrapper wrappen:
        const $stickyWrapper = $( '<div class="sticky-wrapper"></div>' );
        if (reverseGarage) {
            $(container1).find('> *').appendTo($stickyWrapper);
            $(container1).append($stickyWrapper).prepend('<div class="spacer"></div>').append('<div class="layer"></div>').addClass('sticky-garage');
            $(container1).addClass('reverse-garage');
        } else {
            $(container2).find('> *').appendTo($stickyWrapper);
            $(container2).append($stickyWrapper).append('<div class="spacer"></div>').append('<div class="layer"></div>').addClass('sticky-garage');
        }

        if (!reverseGarage) {
            // Opacity Layer aufhellen & Effekte triggern, sobald Garagentor Elemente freilegt:
            const {triggerEffects} = {triggerEffects: [], ... options};
            // nur für Seite Laden, bevor gescrollt wurde:
            triggerEffects.forEach(effect => {
                $(container2).find(`.${effect}`).each((index, ele) => {
                    const $ele = $(ele);
                    const eleBottomPos = 1 - ($ele.offset()!.top - $(window).scrollTop()! + $ele.height()!) / window.innerHeight;
                    const garageBottomPos = 1 - ($(container1).offset()!.top - $(window).scrollTop()! + $(container1).height()!) / window.innerHeight;
                    if (garageBottomPos < eleBottomPos) {
                        $ele.addClass(`${effect}-show`);
                    }
                });
            });
            const layer = $(container2).find('.layer')[0];
            const isMobileFooter = isPhone && $(container2).hasClass('footer-section');
            watcher.add({
                element: container1,
                onProgress: (element, {lowerProgress}, direction) => {
                    const opacity = 1 - lowerProgress;
                    if (direction) { //kann nach dem Laden 0 sein
                        if (!isMobileFooter) {
                            layer.style.opacity = `${opacity}`;
                        }
                        triggerEffects.forEach(effect => {
                            $(container2).find(`.${effect}`).each((index, ele) => {
                                const $ele = $(ele);
                                const eleBottom = ele.getBoundingClientRect().bottom;
                                const containerBottom = container1.getBoundingClientRect().bottom;
                                $ele.toggleClass(`${effect}-show`, eleBottom > containerBottom);
                            });
                        });
                    }
                }
            });
            // weil footer in mobil nicht 100 vh hoch sind:
            if (isMobileFooter) {
                watcher.add({
                    element: layer,
                    onProgress: (element, {outroProgress}, direction) => {
                        const opacity = 1 - outroProgress;
                        if (direction) { //kann nach dem Laden 0 sein
                            layer.style.opacity = `${opacity}`;
                        }
                    }
                });
            }
        } else {
            // Opacity Layer abdunklen, sobald sich bei reverse Garagentor container2 über container1 schiebt:
            // TODO?
            // watcher.add({
            //     element: container2,
            //     onProgress: (element, {upperProgress}, direction) => {
            //         const opacity = upperProgress;
            //         if (direction) { //kann nach dem Laden 0 sein
            //             $(container1).find('.layer')[0].style.opacity = `${opacity}`;
            //         }
            //     }
            // });
        }
    }
}

export default StickyGarage;
